import { post as fetchPost } from './fetch-api'

const BASE_URL = '/services/plugin-language-query-rest-pipes'

export const search = (assetType: string, params: URLSearchParams, body: any): Promise<any> => {
    return fetchPost(`${BASE_URL}/${assetType}`, body, null, params)
}

export const searchCount = (assetType: string, params: URLSearchParams, body: any): Promise<any> => {
    return fetchPost(`${BASE_URL}/${assetType}/count`, body, null, params)
}
